module.exports = __webpack_public_path__ + "static/media/pic_jl.2142d152.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pic_jl.jpg
// module id = 1842
// module chunks = 0 1